<template>
  <div class="btn_group">
    <button
      v-if="buttonStates.divisionNotStart"
      type="button"
      class="btn_default-a"
      @click="$emit('on-cancel-order')"
    >
      결제취소
    </button>
    <button
      v-if="onDeliveryChangeBtn"
      type="button"
      class="btn_default-b"
      @click="$emit('delivery-change')"
    >
      배송지변경
    </button>
  </div>
</template>

<script>
export default {
  name: "HistoryItemBtnGroup",
  components: {},
  props: {
    buttonStates: {
      type: Object,
      default: () => ({}),
    },
    deliveryChangeBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  computed: {
    onDeliveryChangeBtn() {
      if (this.buttonStates.divisionNotStart && this.deliveryChangeBtn) {
        return true;
      }
      return false;
    },
  },
  methods: {},
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/mypacks/detail/partial/history-part/HistoryItemBtnGroup.vue